// Mirrors ProfileStore / MonitorStore / LlmDataStore / WidgetConfigStore:
// small localStorage-backed caches so screens can render instantly on
// re-open and refresh underneath, instead of blank-loading every time.

function read(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}
function write(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export const ProfileStore = {
  get: () => read("tg_profile_cache", null),
  save: (user) => write("tg_profile_cache", user),
};

export const MonitorStore = {
  get: () => read("tg_monitor_cache", null),
  save: (snapshot) => write("tg_monitor_cache", snapshot),
};

export const LlmDataStore = {
  getCredentials: () => read("tg_credentials_cache", []),
  saveCredentials: (list) => write("tg_credentials_cache", list),
  getCatalog: () => read("tg_catalog_cache", []),
  saveCatalog: (list) => write("tg_catalog_cache", list),
};

export const WidgetConfigStore = {
  get: () => read("tg_widget_config_cache", null),
  save: (cfg) => write("tg_widget_config_cache", cfg),
};
